(function ($, Drupal) {
  'use strict';
  /**
   * Attaches the accordion toggle controls to the accordion items.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Adds and removes active class.
   */
  Drupal.behaviors.ucwsAccordion = {
    attach: function (context, settings) {

      //
      // Accordion open/close state control.
      //

      $('.panel-collapse').on('show.bs.collapse', function (e) {
        // Show Accordion section.
        $(e.target)
          .prev('.panel-heading')
          .addClass('active');
      }).on('hide.bs.collapse', function (e) {
        // Hide Accordion section.
        $(e.target)
          .prev('.panel-heading')
          .removeClass('active');
      });

    }
  };

})(jQuery, Drupal);
